import { Anchor, type _Navigation } from ":setup/qrouter";
import { default as routes } from "../routes";
import { global } from ":shared/app";
import { LockedAnchor } from ":src/components/overlays";
export default function VirtualLobby(props: _Navigation.SideNavJSXItemProps) {
  const $settings = global.store.hooks.platform.useSettings("virtual_lobby");
  return (
    <Anchor
      class={`relative  ${props?.anchor?.class ?? ""}`}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      events={{
        getShouldNavigate: () => !$settings().locked,
      }}
      triggers={{
        onBeforeNavigate: () => {
          if ($settings().locked) {
            global.store.actions.toast.pushToast({
              type: "error",
              message: "This page is locked by admin, you can't access it right now!",
            });
          }
        },
      }}
      components={{
        title: "Virtual Lobby",
        idleIcon: <i class="i-eos-icons:virtual-guest" />,
        activeIcon: <i class="i-eos-icons:virtual-guest" />,
      }}
    >
      <LockedAnchor locked={$settings().locked} />
    </Anchor>
  );
}
